import siteContextStore from '@/shared/content/site-context.store';
import {
    B2CFooterViewModel,
    B2CSiteContextModel,
    Country,
    FranchiseSetup,
    FreightInfoModel,
    LinkModel,
} from '@/types/B2CcontentServerContract';

class SiteContextService {
    get settings(): B2CSiteContextModel {
        return siteContextStore.settings as B2CSiteContextModel;
    }

    get country(): Country {
        return this.settings.country;
    }

    get resetPasswordSettings(): string {
        return this.settings.resetPasswordSettings;
    }

    get profileActivationSettings(): string {
        return this.settings.profileActivationSettings;
    }

    get frontPageUrl(): string {
        return this.settings.frontPageUrl;
    }

    get loginLink(): LinkModel {
        return this.settings.loginLink;
    }

    get b2bLoginLink(): LinkModel | undefined {
        return this.settings.b2BLoginLink;
    }

    get createProfileLink(): LinkModel {
        return this.settings.createProfileLink;
    }

    get findStoresLink(): LinkModel {
        return this.settings.findStoresLink;
    }

    get isBrandSite(): boolean {
        return this.settings.isBrandSite;
    }

    get isDcdFranchise(): boolean {
        return this.settings.franchiseSetup === FranchiseSetup.Dcd;
    }

    get basketIsDisabled(): boolean {
        return this.settings.disableBasket;
    }

    get isHaOnlineEnabled(): boolean {
        return this.settings.isHaOnlineEnabled;
    }

    get freightInfo(): FreightInfoModel {
        return this.settings.freightInfoModel;
    }

    get isNewCheckOutEnabled(): boolean {
        return this.settings.isNewCheckOutEnabled;
    }

    get footer(): B2CFooterViewModel {
        return this.settings?.footer ?? {
            columns: [],
            copyrightText: 'string',
        };
    }
}

export default new SiteContextService();
